<!--
  name : 이예닮
  desc : 블록체인관리
  date : 2021-07-19
-->
<template>
  <v-container id="set_chain" class="con_mpw">
    <v-row no-gutters class="row_mt-40 row_mb-40">
      <div class="dot_tt">블록체인 주소</div>
      <v-row no-gutters class="feepay_round_box row_mt-20 row_mb-20">
        <v-col cols="12" class="posiR">
          <ul class="pattern_ulTxtBox">
            <li v-if="activeName === 'company'">
              <v-chip class="conFrom st_cpn">기업</v-chip>
              <span class="txt_txt01 no_pr">{{ this.user.orgname }}</span>
              <span class="txt_txt02"
                >({{ this.user.orgreg | regNumFilter }})</span
              >
            </li>
            <li v-if="activeName === 'company'">
              <span class="txt_tt">{{ this.user.orgaddr }}</span>
            </li>
            <li v-if="activeName === 'personal'">
              <v-chip class="conFrom">개인</v-chip>
              <span class="txt_txt01 no_pr">{{ this.user.username }}</span>
              <span class="txt_txt02">({{ this.user.useremail }})</span>
            </li>
            <li v-if="activeName === 'personal'">
              <span class="txt_tt">{{ this.user.useraddr }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row no-gutters class="posiR_W100 row_mb-20">
        <v-btn class="btn17_C01" @click="chainpwPop = true"
          >비밀번호 변경</v-btn
        >
        <v-btn class="btn17_C01" @click="downloadKeystoreFile()"
          >블록체인 다운로드</v-btn
        >
      </v-row>

      <v-row no-gutters class="posiR_W100">
        <v-col cols="12">
          <v-switch
            class="row_mb-8"
            v-model="isChainPub"
            label="수신자 검색 허용"
            @change="changeChkbox"
          ></v-switch>
        </v-col>
        <v-col cols="12"
          ><div class="txtst_info_gray">
            - 글로싸인엔터프라이즈에 등록된 사용자가 계약 수신자를 검색할 수
            있도록 허용합니다.
          </div></v-col
        >
      </v-row>
    </v-row>

    <!--(Popup)비밀번호 변경-->
    <v-dialog
      v-model="chainpwPop"
      @keydown.esc="chainpwPop = false"
      max-width="600px"
      persistent
    >
      <v-card id="popStyle03">
        <!-- title -->
        <v-card-title class="title">
          블록체인 비밀번호 변경
          <v-btn fab class="popBtnClose" @click="chainpwPop = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="popCon">
            <div class="popCon_txt">
              현재 사용하는 비밀번호를 입력한 후 새로 사용할 비밀번호를
              입력하세요. (영어, 숫자 포함하여 6~12자리)
            </div>
            <div class="popCon_input_W100_cov">
              <v-text-field
                class="inputH48_01 conBstar"
                label="현재 비밀번호"
                value="현재 비밀번호 입력"
                outlined
                dense
                v-model="currentPw"
                ref="passwordRules1"
                :rules="rules.passwordRules"
              >
              </v-text-field>
              <v-text-field
                class="inputH48_01 conBstar"
                label="신규 비밀번호"
                value="영어, 숫자 포함 6~12자리로 입력"
                outlined
                dense
                v-model="newPw"
                ref="passwordRules2"
                :rules="rules.passwordRules"
              >
              </v-text-field>
              <v-text-field
                class="inputH48_01 conBstar"
                label="신규 비밀번호 확인"
                value="영어, 숫자 포함 6~12자리로 입력"
                outlined
                dense
                v-model="newPwCk"
                ref="passwordRules3"
                :rules="rules.passwordRules"
              >
              </v-text-field>
            </div>
          </v-row>
        </v-card-text>
        <!-- button -->
        <v-card-actions class="justify-center">
          <v-btn class="btn_C01" text @click="changePass()">확인</v-btn>
          <v-btn text @click="chainpwPop = false">취소</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>
<script>
import {
  changeChainPass,
  changeChainPub,
  getChainSetting
} from "@/api/setting/setting";

export default {
  name: "chainSetting",
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      rules: {
        passwordRules: [
          v => !!v || "비밀번호를 입력해 주세요",
          v =>
            /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) ||
            "영어, 숫자 포함하여 6~12자리로 입력해 주십시요"
        ]
      },

      chainpwPop: false, // 팝업
      activeName: "",

      // 비밀번호 변경시 사용자 입력 변수
      currentPw: "",
      newPw: "",
      newPwCk: "",

      // 비밀번호 변경시 Json 보내는 array
      chgPassParams: {
        chainAddress: null,
        currPass: null,
        changePass: null
      },

      // 수신자 검색 허용
      isChainPub: false,
      chgAdrPubParams: {
        chainAddress: null,
        isChainPub: false,
        activeName: null
      }
    };
  },
  created() {},
  mounted() {
    this.user = this.$store.state.user;
    if (this.$store.state.user.orgaddr) {
      this.activeName = "company";
      this.chainAddress = this.user.orgaddr;
    } else {
      this.activeName = "personal";
      this.chainAddress = this.user.useraddr;
    }
    this.getChainSetting();
  },
  methods: {
    // 비밀번호 변경
    changePass() {
      if (
        this.$refs.passwordRules1.validate() &&
        this.$refs.passwordRules2.validate() &&
        this.$refs.passwordRules3.validate()
      ) {
        this.chgPassParams.chainAddress = this.chainAddress;
        this.chgPassParams.currPass = this.currentPw;
        this.chgPassParams.changePass = this.newPw;

        this.$refs.loading.start("입력 정보 확인 중");
        changeChainPass(this.chgPassParams)
          .then(response => {
            if (response.rdata.changeStatus === "success") {
              this.$refs.loading.end();
              this.$refs.confirm.open(
                "alert",
                "비밀번호 변경",
                "비밀번호를 변경했습니다."
              );
              this.chainpwPop = false;
            } else {
              this.$refs.loading.end();
              this.$refs.confirm.open(
                "alert",
                "비밀번호 변경",
                response.rdata.errMsg
              );
            }
            this.currentPw = "";
            this.newPw = "";
            this.newPwCk = "";
          })
          .catch(e => {
            this.$refs.confirm.open(
              "alert",
              "비밀번호 변경",
              "비밀번호 변경중 에러가 발생 하였습니다."
            );
          });
      } else {
        this.$refs.confirm.open(
          "alert",
          "비밀번호 변경",
          "비밀번호 형식을 확인 해주세요."
        );
      }
    },

    // 블록체인 다운로드
    downloadKeystoreFile() {
      window.location.href =
        process.env.VUE_APP_DOWNLOAD_CHAIN_URL + this.chainAddress;
    },

    // 수신자 검색허용 정보
    getChainSetting() {
      getChainSetting(
        JSON.stringify({
          activeName: this.activeName,
          chainAddress: this.chainAddress
        })
      )
        .then(response => {
          this.isChainPub = response.rdata.chainPub;
        })
        .catch(e => {});
    },

    // 수신자 검색허용
    changeChkbox() {
      this.chgAdrPubParams.activeName = this.activeName;
      this.chgAdrPubParams.isChainPub = this.isChainPub;
      this.chgAdrPubParams.chainAddress = this.chainAddress;
      changeChainPub(this.chgAdrPubParams)
        .then(response => {
          if (response.rdata.result === "success") {
            this.$refs.confirm.open(
              "alert",
              "블록체인 검색 설정",
              "설정이 변경되었습니다."
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "블록체인 검색 설정",
              "설정 변경을 실패했습니다. 관리자에게 문의해주세요. ( error message : " +
                response.rdata.message +
                ")"
            );
          }
        })
        .catch(e => {});
    }
  }
};
</script>
<style scoped></style>
